<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="10">
        <div class="form-group">
          <label
                  for="excmuserdataworkplace_title"
                  class="form-control-label">{{$t('views.excmuserdataworkplace.form.title')}}:</label>
          <input
                  id="excmuserdataworkplace_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
    </b-row>

    <button
      type="submit"
      class="btn btn-primary">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
